import axios from "axios";
import { BASE_URL } from "@/env";
export default async function setToken() {
  try {
    let refresh = localStorage.getItem("refreshToken"); ///se toma el token refresh

    const apiClient = axios.create({
      baseURL: BASE_URL,
      withCredentials: false,
      headers: {
        "auth-header": localStorage.getItem("token"),
      },
    });

    const respuesta = await apiClient.post("/refresh-token", {
      refreshToken: refresh,
    });
    console.log(respuesta);
    if (respuesta.status === 200) {
      const newToken = respuesta.data.Token;
      localStorage.setItem("token", newToken);

      return true;
    } else {
      console.log("Error al refrescar token, estado:", respuesta.status);
      return false;
    }
  } catch (error) {
    console.log("Error al renovar el token:", error);
    return false;
  }

  // .then((response) => {
  //   return response
  //   // localStorage.setItem("token", response.data.Token);
  // })
  // .catch((error) => {
  //   console.log(error.response, "soy el error del refreshToken");
  // });
}
